import { api } from '@iblai/ibl-web-react-common';
import { getTenant, getUserName } from '../helpers';

export function getNotifications(query = {}, callback) {
  const param = new URLSearchParams(query).toString();
  const url = `${process.env.REACT_APP_IBL_DM_URL}/api/notification/v1/orgs/${getTenant()}/users/${getUserName()}/notifications/?${param}`;
  fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Token ${localStorage.getItem('axd_token')}`,
    },
  })
    .then((response) =>
      response
        .json()
        .then(callback)
        .catch((err) => callback({}))
    )
    .catch((err) => callback({}));
}

export function markAllNotificationsAsRead(callback) {
  const url = `${process.env.REACT_APP_IBL_DM_URL}/api/notification/v1/orgs/${getTenant()}/mark-all-as-read`;
  fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Token ${localStorage.getItem('dm_token')}`,
    },
  })
    .then((response) =>
      callback(response.ok)
    )
    .catch((err) => callback(false));
}

export function markNotificationAsRead(notificationData, callback) {
  api.iblaxdApiCallWrapper(
    (args) =>
      api.iblaxdnotificationapi.notificationV1OrgsUsersNotificationsUpdate(
        ...args
      ),
    getTenant(),
    getUserName(),
    notificationData
  )((err, data, response) => callback(err, data, response));
}

export function getFilteredNotifications(filterData, callback) {
  api.iblaxdApiCallWrapper(
    (args) =>
      api.iblaxdnotificationapi.notificationV1OrgsUsersNotificationsRetrieve(
        ...args
      ),
    getTenant(),
    getUserName(),
    filterData
  )((err, data, response) => callback(err, data, response));
}

export const fetchNotificationCount = (callback) => {
  api.iblaxdApiCallWrapper(
    (args) =>
      api.iblaxdnotificationapi.notificationV1OrgsUsersNotificationsCountRetrieve(
        ...args
      ),
    getTenant(),
    getUserName(),
    { status: 'UNREAD' }
  )((err, data, response) => callback(response));
};
